import React, { useState } from 'react';
import { Spreedly, GlobalPayments } from './index'
import PropTypes from 'prop-types';

const { forwardRef, useRef, useImperativeHandle } = React;

//const Payments = props => {
const Payments = forwardRef((props, ref) => {

    const { type, showFreeTkt, managemyBooking, mmbPayBy } = props;

    const spreedlyRef = useRef();
    const globalPaymentsRef = useRef();


    useImperativeHandle(ref, () => ({

        SpreedlyTransactionCall(requiredFields) {
            spreedlyRef.current.TransactionCall(requiredFields);
        },
        SpreedlyZeroDollarTransactionCall(requiredFields) {
            spreedlyRef.current.ZeroDollarTransactionCall(requiredFields);
        },
        ReloadSpreedly() {
            spreedlyRef.current.ReloadSpreedly();
        },
        PaymentLoaded() {
            spreedlyRef.current.PaymentLoaded();
        },
        SpreedlyCardOnFileTransaction() {
            spreedlyRef.current.CardOnFileTransaction();
        },
        PayByCardOnFile() {
            globalPaymentsRef.current.refPayByCardOnFile();
        },
        GPReload() {
            globalPaymentsRef.current.refReload();
        }
    }));

    return (
        <div>
            {type === 'Spreedly' ? <Spreedly ref={spreedlyRef} /> : null}

            {type === 'GlobalPayments' ?
                <GlobalPayments onClick={props.onClick}
                    ref={globalPaymentsRef}
                    showFreeTicket={showFreeTkt}
                    ValidatePaymentFields={props.ValidatePaymentFields}
                    managemyBooking={props.managemyBooking}
                    mmbPayBy={props.mmbPayBy}
                    AdditionBooking={props.AdditionBooking}
                /> : null}

        </div >
    );
});

Payments.propTypes = {
    type: PropTypes.string.isRequired,
    tokenization: PropTypes.func.isRequired
};

export default Payments;
